import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "light-dark" }
const _hoisted_2 = { class: "material-symbols-outlined" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "switch-toggle settings-btn dark-btn p-0 bg-transparent",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args)))
    }, [
      _createElementVNode("span", null, [
        _createElementVNode("i", _hoisted_2, _toDisplayString(_ctx.icon), 1)
      ])
    ])
  ]))
}